import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrTextComponent } from './tr-text.component';
import { TipLinkModule } from '../../tip-link/tip-link.module';
import { TooltipDirectiveModule } from './../../../directives';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TipLinkModule,
        TooltipDirectiveModule
    ],
    exports: [ TrTextComponent ],
    declarations: [ TrTextComponent ],
})
export class TrTextModule {}
